<template>
    <div style="width: 100%">
        <el-row class="ordinary" :gutter="60">
            <!--            class="col"-->

            <el-col
                    style="margin: 10px 0;"
                    :xs="12"
                    :sm="12"
                    :md="6"
                    :lg="6"
                    :xl="6"
                    v-for="(item2, index2) in hxContentList"
                    :key="index2"

            >
                <div @click="productClick(item2)"
                     style="display: flex;justify-content: center;flex-direction: column;align-items: center;line-height: 28px">
                    <el-image
                            class="product-image"
                            :src="item2.url"/>
                    <div style="margin-top: 10px;;color: #0094ff;cursor: pointer">
                        {{item2.title}}
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "card-index",
        props: {
            hxContentList: Array
        },
        methods: {
            // 跳转产品详情
            productClick(data) {
                this.$router.push({
                    path: "/productDetails",
                    query: {
                        contentId: data.contentId,
                    },
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .ordinary {
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
        /*overflow-y: hidden;*/
    }

    .product-image {
        transition: all .5s;
        /*width: 220px;*/
        /*height: 220px;*/
        width: 100%;
        aspect-ratio:1/1;
        border-radius: 6px;

        &:hover {
            transform: translateY(-10px);
            cursor: pointer;
        }
    }

    .type-area {
        width: 100%;
        margin: 0 auto;
    }

    /*.col {*/
    /*    padding: 0 50px;*/
    /*}*/

    @media screen and (min-width: 1400px) {
        /*.col {*/
        /*    padding: 0 50px;*/
        /*}*/

        .type-area {
            width: 100%;
            margin: 0 auto;
        }
    }

    @media screen and (min-width: 1200px) {
        /*.col {*/
        /*    padding: 0 50px;*/
        /*}*/
    }

    @media screen and (max-width: 1200px) {
        /*.col {*/
        /*    padding: 0 50px;*/
        /*}*/
    }

    @media screen and (max-width: 870px) {
        .type-area {
            width: 100%;
            margin: 0 auto;
        }

        .row {
            margin: 0 20px !important;
        }

        /*.col {*/
        /*    margin-top: 20px;*/
        /*    padding: 0 20px;*/
        /*}*/
    }

    @media screen and (max-width: 570px) {
        .type-area {
            width: 100%;
            margin: 0 auto;
        }

        .row {
            margin: 0 20px !important;
        }

        /*.col {*/
        /*    margin-top: 20px;*/
        /*    padding: 0 20px;*/
        /*}*/

        .product-image {
            width: 160px;
            height: 160px;
        }

        /*.phone{*/
        /*    padding: 0 10px;*/
        /*}*/
    }

    @media screen and (max-width: 380px) {
        .product-image {
            width: 150px;
            height: 150px;
        }

    }
</style>
